/**
 * Growth-projection assumptions for the gift amount screen (GIFTWEB-15).
 * An annual gift of the chosen amount on each birthday for 18 years at
 * low/medium/high average annual growth, rounded to the nearest £10.
 */
export const PROJECTION_YEARS = 18;

export const GROWTH_RATES = Object.freeze({
  low: 0.02,
  medium: 0.05,
  high: 0.08,
});

/** The band as the assumptions copy says it, so the two cannot drift apart. */
export const growthRateLabel = (rate: number) => `${Math.round(rate * 100)}%`;

/**
 * Future value of `amount` gifted once a year for `years` years at `rate`
 * (annuity-due-free, end-of-year compounding: amount × ((1+r)^n − 1) / r),
 * rounded to the nearest 10.
 */
export function projectAnnualGifts(
  amount: number,
  rate: number,
  years: number = PROJECTION_YEARS,
): number {
  const futureValue = amount * ((Math.pow(1 + rate, years) - 1) / rate);
  return Math.round(futureValue / 10) * 10;
}
